import React, { useEffect, useRef, useState } from "react";
import IncomeTaxReturnAcceptedNotificationModal, {
  IncomeTaxReturnAcceptedNotificationModalApi,
} from "components/modal/IncomeTaxReturnAcceptedNotificationModal";
import { getNotifications } from "store/api/apiSlice";
import { ApiNotificationType } from "utils/api/notifications";

const NOTIFICATIONS_WITH_ALERT = [ApiNotificationType.incomeTaxReturnAccepted];

const NotificationAlerts = () => {
  const incomeTaxReturnAcceptedModalRef =
    useRef<IncomeTaxReturnAcceptedNotificationModalApi>(null);
  const [hasShownAlert, setHasShownAlert] = useState(false);
  const { data: notifications } = getNotifications();

  const notificationsWithAlert = notifications?.filter((notification) =>
    NOTIFICATIONS_WITH_ALERT.includes(notification.type)
  );

  useEffect(() => {
    // To avoid being disruptive for now, we'll only show the first notification with an alert, and only once per instantiation of this component
    if (notificationsWithAlert?.length && !hasShownAlert) {
      const notificationToShow = notificationsWithAlert[0];

      switch (notificationToShow.type) {
        case ApiNotificationType.incomeTaxReturnAccepted:
          incomeTaxReturnAcceptedModalRef.current?.show(notificationToShow);
          break;
        default:
      }

      setHasShownAlert(true);
    }
  }, [notificationsWithAlert]);

  return (
    <>
      <IncomeTaxReturnAcceptedNotificationModal
        ref={incomeTaxReturnAcceptedModalRef}
      />
    </>
  );
};

export default NotificationAlerts;
